module.exports = __webpack_public_path__ + "img/demo03.312c678b.png";